import { useParams, useSearchParams } from "react-router-dom";
import type { SkillKey } from "./api.ts";

/**
 * Reads the unit key from routes shaped /skills[/edit]/:scope/:agent/*name
 * plus the optional ?project= query (scope=project only).
 */
export function useSkillKey(): SkillKey {
  const params = useParams();
  const [search] = useSearchParams();
  return {
    scope: params.scope ?? "",
    agent: params.agent ?? "",
    name: params["*"] ?? "",
    project: search.get("project") ?? undefined,
  };
}

/** Link to a skill's detail (or edit) page. */
export function skillHref(key: SkillKey, edit = false): string {
  const base = edit ? "/skills/edit" : "/skills";
  const name = key.name.split("/").map(encodeURIComponent).join("/");
  const q = key.project ? `?project=${encodeURIComponent(key.project)}` : "";
  return `${base}/${encodeURIComponent(key.scope)}/${encodeURIComponent(key.agent)}/${name}${q}`;
}

/** Last path segment: "skills/deploy" -> "deploy", "CLAUDE.md" -> "CLAUDE.md". */
export function basename(p: string): string {
  const parts = p.split("/").filter(Boolean);
  return parts[parts.length - 1] ?? p;
}

/** Display name for a unit: "skills/deploy" -> "deploy". */
export function unitLabel(name: string): string {
  return basename(name);
}
